import './resource-show-main-col.css';
